import { ResourceKey } from "i18next";

export const CompanyPage: ResourceKey = {
    award: "attribution",
    bid: "offre",
    company_information_section_title: "Informations sur l'entreprise",
    competitors: "Concurrents",
    buyers: "Acheteurs",
    suppliers: "Fournisseurs",
    copied_to_clipboard_title_1: 'Texte "',
    copied_to_clipboard_title_: '" copié dans le presse-papiers',
	win_ratio_title_1: "Ratio de gain",
	win_ratio_title_2: "dans les marchés publics",
	win_ratio_significant_increase: "augmentation significative",
	win_ratio_significant_decrease: "baisse significative",
	win_ratio_moderate_increase: "augmentation modérée",
	win_ratio_moderate_decrease: "baisse modérée",
	win_ratio_minor_change: "changement mineur",
	experience_graph_type_tenders_won: "Marchés Gagnés",
	experience_graph_type_bids_won: "Offres Gagnées",
	experience_title_2_tenders_won: "Aucune donnée de marchés gagnés pour comparaison",
	experience_tenders_won_minor_change: "changement mineur",
	experience_tenders_won_moderate_increase: "augmentation modérée",
	experience_tenders_won_moderate_decrease: "baisse modérée",
	experience_tenders_won_significant_increase: "augmentation significative par rapport à l'année dernière",
	experience_tenders_won_significant_decrease: "diminution significative par rapport à l'année dernière",
	graphLabel: {
		bids: 'Offres',
		wins: 'Gains',
		date: 'Date',
		value: 'Valeur',
		bid: 'Offre',
		tenders_won: "Marchés Gagnés",
	},

    follow_company: "Suivre cette entreprise: tenez-moi informé lorsque cette entreprise participe à un marché public et fournissez un aperçu dans l'onglet 'Attribution'",
    followed_company: "Entreprise suivie: ",
    main_activities_section_title: "Types de marchés publics",
    main_buyers_section_title: "Principaux acheteurs",
    projects_contracted_title_1: "Marchés attribués",
    projects_contracted_title_2: "à l'entreprise ci-dessus",
    recent_activity_section_title: "Marchés publics récents",
    recently_participated_in_section_title: "Participé",
    contracted_open_section_title: "Marchés publics ouverts",
    contracted_closed_section_title: "Marchés publics fermés",
    recently_won_section_title: "Gagné",
    shared_projects_title: "Projets partagés",
    company_experience_title: "Expérience",
    show_company_page: "Afficher la page d'entreprise",
    tendering: "Appels d'offres",
    tenders_contracted_closed_title: "Appels d'offres récemment lancés",
    tenders_contracted_open_title: "Appels d'offres ouverts",
    unknown_company: "Entreprise inconnue",
    direct_competitor_title_1: "Concurrent direct",
    direct_competitor_title_2: "marchés publics",
    shared_projects_title_1: "Contrats attribués",
    shared_projects_title_2: "de l'entreprise ci-dessus",
    company_info_details_title: "Détails",
    company_info_contact_title: "Contact",
    company_info_activities_title: "Activités",
    company_info_accreditations_title: "Accréditations",
    company_info_start_date_title: "Date de début",
    price: "Prix",
    quality: "Qualité",
    balanced: "Hybride",
    orientation: "Focus",
    priceOriented: "Prix",
    qualityOriented: "Qualité",
    averageLotValue: "Taille",
    verySmallScale: "Très petit",
    smallScale: "Petit",
    mediumScale: "Moyen",
    largeScale: "Grand",
    veryLargeScale: "Très grand",
    government_category_title: "Cherchez gouvernements",
    company_category_title: "Cherchez entreprises",
    offers_and_awards_title: "Offres & Attributions",
    frameworks_title: "Contrats expirants",
    has_tender_experience: "Actif dans les marchés publics",
    lot_value_title_2: "basé sur les offres gagnantes cette année",
    lot_value_significant_increase: "augmentation significative par rapport à l'année dernière",
    lot_value_significant_decrease: "diminution significative par rapport à l'année dernière",
    lot_value_moderate_increase: "augmentation modérée par rapport à l'année dernière",
    lot_value_moderate_decrease: "diminution modérée par rapport à l'année dernière",
    lot_value_minor_change: "par rapport à l'année dernière",
    win_ratio_increase: "augmentation vs l'année dernière",
    win_ratio_decrease: "baisse vs l'année dernière",
    win_ratio_no_change: "aucun changement vs l'année dernière",
    lot_value_increase: "augmentation vs l'année dernière",
    lot_value_decrease: "baisse vs l'année dernière",
    lot_value_no_change: "aucun changement vs l'année dernière",
    experience_tenders_won_increase: "augmentation vs l'année dernière",
    experience_tenders_won_decrease: "baisse vs l'année dernière",
    experience_tenders_won_no_change: "aucun changement vs l'année dernière",
    orientation_increase_price: "focus prix accru vs l'année dernière",
    orientation_decrease_price: "focus prix réduit vs l'année dernière",
    orientation_no_change: "focus prix identique vs l'année dernière",
    bidStatus: {
        won: "Gagné",
        lost: "Perdu",
        not_known: "Inconnu",
    },
    lotValueLabel: "Valeur du lot",
    tenders_plural: "appels d'offres",

    win_ratio_graph_type: "Taux de gain",
    lot_value_graph_type_scatter: "Valeurs des lots",
    orientation_graph_type: "Orientation",

    orientationTooltip: {
        priceFocus: "Focus Prix",
        priceCount: "Gains (Prix)",
        qualityCount: "Gains (Qualité)",
    },

    // Tooltips for WinRateGraph (FR)
    winrateGraph: {
        tooltipExpand: "Cliquer pour afficher les détails",
        tooltipCollapse: "Cliquer pour afficher le résumé",
    },
    statistics_tab_title: "Statistiques",
};
